import { Injectable, inject } from '@angular/core';
import { OmniSearchService } from '@brighthub/search';
import { ClientSearchProvider } from '@brightnav/ui';
import { ConversationSearchProvider } from '@brighthub/brightnav-conversation-search';
import { EmployeeSearchProvider } from '@brighthub/brightnav-employee-search';

/**
 * Registers BrightNav omni-search providers with {@link OmniSearchService}.
 *
 * Provider instances are taken from field `inject()` (construction-time DI context), not from
 * `inject()` inside {@link registerProviders} — that method can run outside a reliable
 * injection context and silently skip conversation/employee providers.
 */
@Injectable({
  providedIn: 'root'
})
export class BrightNavOmniSearchRegistry {
  private readonly _search = inject(OmniSearchService);
  private readonly _client = inject(ClientSearchProvider);
  private readonly _conversation = inject(ConversationSearchProvider);
  private readonly _employee = inject(EmployeeSearchProvider);

  registerProviders(): void {
    // One signal write so the omni bar never briefly sees only `client` and auto-locks.
    this._search.registerProviders([
      this._client,
      this._conversation,
      this._employee,
    ]);
  }
}
